// extracted by mini-css-extract-plugin
export default {"loginImage":"StepInfo_loginImage__IVD8F","headerText":"StepInfo_headerText__aouta"};